module.exports = __webpack_public_path__ + "img/el_get.e3c85f3.png";